import React, { useState } from 'react';

import { useRecoilValue } from 'recoil';

import InventoryStore from 'src/app_deprecated/stores/InventoryStore';

import { inventoryAtom } from 'src/app/state/inventory';

import { QueryBuilderMultiSelect } from './shared/query-builder-multi-select';

type TagDropdownProps = {
  disabled?: boolean;
  onChange: (value: (number | string)[]) => void;
  values: string;
};

type Tag = {
  id: number;
  name: string;
};

export function TagDropdown({ onChange, values, disabled = false }: TagDropdownProps) {
  const [loading, setLoading] = useState(false);
  const { tags } = useRecoilValue(inventoryAtom);

  const transformedTags: Tag[] = (tags || []).map((tag) => ({
    id: tag.TagId,
    name: tag.TagName,
  }));

  async function handleRefresh() {
    setLoading(true);
    await InventoryStore.refreshBrands();
    setLoading(false);
  }

  return (
    <QueryBuilderMultiSelect<Tag>
      automationIdPrefix='tag'
      defaultLabel='Select a tag'
      disabled={disabled}
      idKey='id'
      items={transformedTags}
      loading={loading}
      nameKey='name'
      refreshData={handleRefresh}
      values={values}
      onChange={onChange}
    />
  );
}
